import { api } from 'lib/request/api';
import type {
  EntityReconcileScoredResponse,
  ReconcileUndoResponse,
} from 'types/api-responses';

// The reconcile calls shared by the profile-page and list-page hooks, so the
// endpoints and payload contracts can't drift between the two entry points.

export const newReconcileSessionId = () =>
  globalThis.crypto?.randomUUID?.() ?? `entity-reconcile-${Date.now()}`;

// Retrieval mode is server-decided (R2): semantic is the default wherever the
// capability flag is enabled, with automatic lexical fallback. There is NO
// user-facing toggle. The `?semantic=1|0` request param is a non-surfaced
// developer/QA override only — read straight off the URL and forwarded as-is;
// when absent we send nothing and let the server pick the mode.
const semanticOverrideParams = (): Record<string, string> => {
  const value = new URLSearchParams(window.location.search).get('semantic');
  return value === null ? {} : { semantic: value };
};

export const fetchScoredCandidates = (entityId: number) =>
  api
    .get(`entities/${entityId}/reconcile_candidates`, {
      searchParams: semanticOverrideParams(),
    })
    .json<EntityReconcileScoredResponse>();

export const undoReconciliation = (
  fromEntityId: number,
  reconciliationId: number,
  sessionId: string
) =>
  api
    .post(
      `entities/${fromEntityId}/reconciliations/${reconciliationId}/undo`,
      // The session the reconcile was CREATED under (captured in the summary).
      { json: { session_id: sessionId } }
    )
    .json<ReconcileUndoResponse>();
